<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
        <Layout v-show="ready"
                container-class="flex flex-col justify-center min-h-screen py-10 sm:min-h-0 bg-primary">
            <div v-if="ready" class="w-full max-w-sm px-10 mx-auto">
                <BackButton location="Login" />
                <div class="flex justify-center mb-8">
                    <img :src="config.service_logo" :alt="config.service_name"
                         class="block w-auto h-12">
                </div>
                <h1 class="mb-8 text-xl font-bold leading-tight text-center text-highlight-100">
                    {{ _('reset_title') }}
                </h1>
                <p class="mb-8 text-center text-highlight-60">
                    {{ _('reset_description') }}
                </p>
                <form @submit.prevent="submit">

                    <EmailField
                        class="mb-6"
                        :label="_('reset_label_email')"
                        v-model="form.email"
                        :validation.sync="valid.email"
                    />

                    <template v-if="submitted">
                        <p v-if="error" class="px-4 mb-8 text-xs text-center text-error">
                            {{ error }}
                        </p>
                        <p v-else class="px-4 mb-8 text-xs text-center text-highlight-60">
                            {{ _('reset_success') }}
                        </p>
                    </template>

                    <BaseButton type="button" :disabled="!isValid">
                        {{ _('reset_button_reset') }}
                    </BaseButton>

                </form>
            </div>
        </Layout>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import NProgress from 'nprogress'
import Layout from '@/components/Layout.vue'
import BaseButton from '@/components/Base/BaseButton.vue'
import EmailField from '@/components/Form/Fields/EmailField.vue'
import BackButton from '@/components/BackButton.vue'
import AuthService from '../services/AuthService'

const authService = new AuthService()

export default {
    components: {
        BackButton,
        Layout,
        BaseButton,
        EmailField,
    },
    data() {
        return {
            valid: {
                email: false,
            },
            form: {
                email: '',
            },
            error: false,
            submitted: false,
            ready: false,
            config: '',
        }
    },
    computed: {
        ...mapGetters({
            fetched: 'localisation/fetched',
            _: 'localisation/translate',
            client: 'settings/getClient',
            settings: 'settings/get',
        }),
        isValid() {
            return Object.keys(this.valid)
                .every((field) => this.valid[field])
        },
    },
    watch: {
        fetched: {
            immediate: true,
            deep: true,
            handler(fetched) {
                if (fetched) {
                    setTimeout(() => {
                        this.ready = true
                        NProgress.done()
                    }, 1000)
                }
            },
        },
    },
    created() {
        NProgress.start()
    },
    async mounted() {
        this.config = await import(`@/resources/${this.client}`)
    },
    methods: {
        submit() {
            if (this.isValid) {
                this.submitted = false
                this.error = false

                authService
                    .getResetPasswordLink(this.settings, this.form)
                    .then(() => {
                        this.submitted = true
                    })
                    .catch((error) => {
                        this.submitted = true
                        this.error = error.response.data.message
                    })
            }
        },
    },
}
</script>
